import { TombacItem } from "../internal/TombacItem";
export const ComboBoxItem = TombacItem;
//# sourceMappingURL=ComboBoxItem.js.map